const colors = require('tailwindcss/colors');

module.exports = {
    theme: {
        extend: {
            colors: {
                primary: 'var(--color-primary)',
                'primary-inverse': 'var(--color-primary-inverse)',
                secondary: 'var(--color-secondary)',
                'secondary-inverse': 'var(--color-secondary-inverse)',
                tertiary: 'var(--color-tertiary)',
                'tertiary-inverse': 'var(--color-tertiary-inverse)',

                blueGray: colors.slate,
                trueGray: colors.neutral,
                coolGray: colors.gray,
                warmGray: colors.stone,
                red: colors.red,
                orange: colors.orange,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                lightBlue: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose,
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
